// The right-hand panel: every thread on the board, open or resolved.

import { useState } from "react";
import { Close } from "../ui/icons.jsx";
import { Thread } from "./Thread.jsx";

export const PANEL_WIDTH = 360;

const EMPTY = {
  open: "No open comments. Press C, then click a box to leave one.",
  resolved: "No resolved threads yet.",
};

export const CommentsPanel = ({ threads, whereOf, activeId, onFocus, onReply, onResolve, onClose }) => {
  const [filter, setFilter] = useState("open");
  const open = threads.filter((t) => !t.root.resolved);
  const resolved = threads.filter((t) => t.root.resolved);
  // Newest first: the thread somebody just opened is the one you want.
  const shown = [...(filter === "open" ? open : resolved)].reverse();

  return (
    <aside className="comments-panel comment-ui" aria-label="Comments">
      <header className="comments-head">
        <h2>Comments</h2>
        <button type="button" className="btn ghost icon small" onClick={onClose} title="Close the comments">
          <Close />
        </button>
      </header>

      <div className="comments-filter" role="group" aria-label="Show">
        {[
          ["open", "Open", open.length],
          ["resolved", "Resolved", resolved.length],
        ].map(([key, label, count]) => (
          <button
            key={key}
            type="button"
            className={filter === key ? "on" : ""}
            aria-pressed={filter === key}
            onClick={() => setFilter(key)}
          >
            {label}
            <span className="count">{count}</span>
          </button>
        ))}
      </div>

      <div className="comments-list">
        {shown.length === 0 ? <p className="comments-empty">{EMPTY[filter]}</p> : null}
        {shown.map((thread) => {
          const where = whereOf(thread.root);
          return (
            <div
              key={thread.root.id}
              className={`thread-card${thread.root.id === activeId ? " active" : ""}`}
              onClick={(event) => {
                if (!event.target.closest("button, textarea")) onFocus(thread);
              }}
            >
              <Thread thread={thread} where={where.text} gone={where.gone} onReply={onReply} onResolve={onResolve} />
            </div>
          );
        })}
      </div>
    </aside>
  );
};
